import { createGlobalStyle } from "styled-components";

// Importações das fontes Johnson's
import JohnsonsBabyRegularWoff from "~/assets/fonts/johonsons/JohnsonsBaby-Regular.woff";
import JohnsonsBabyRegularWoff2 from "~/assets/fonts/johonsons/JohnsonsBaby-Regular.woff2";
import JohnsonsBabyRegularTtf from "~/assets/fonts/johonsons/JohnsonsBaby-Regular.ttf";
import JohnsonsBabyRegularSvg from "~/assets/fonts/johonsons/JohnsonsBaby-Regular.svg";
import JohnsonsBabyRegularEot from "~/assets/fonts/johonsons/JohnsonsBaby-Regular.eot";

import JohnsonsBabyBoldWoff from "~/assets/fonts/johonsons/JohnsonsBaby-Bold.woff";
import JohnsonsBabyBoldWoff2 from "~/assets/fonts/johonsons/JohnsonBaby-Bold.woff2";
import JohnsonsBabyBoldTtf from "~/assets/fonts/johonsons/JohnsonsBaby-Bold.ttf";
import JohnsonsBabyBoldSvg from "~/assets/fonts/johonsons/JohnsonsBaby-Bold.svg";
import JohnsonsBabyBoldEot from "~/assets/fonts/johonsons/JohnsonsBaby-Bold.eot";

import theme from "./theme";
import reset from "./reset.css";

const GlobalStyle = createGlobalStyle`

@font-face{
  font-family: "JohnsonsBaby";
  src:  url(${JohnsonsBabyRegularWoff2}) format("woff2"),
        url(${JohnsonsBabyRegularWoff}) format("woff"),
        url(${JohnsonsBabyRegularTtf}) format("truetype"),
        url(${JohnsonsBabyRegularSvg}) format("svg"),
        url(${JohnsonsBabyRegularEot}) format("eot");
  font-weight: normal;
};

@font-face{
  font-family: "JohnsonsBaby";
  src:  url(${JohnsonsBabyBoldWoff2}) format("woff2"),
        url(${JohnsonsBabyBoldWoff}) format("woff"),
        url(${JohnsonsBabyBoldTtf}) format("truetype"),
        url(${JohnsonsBabyBoldSvg}) format("svg"),
        url(${JohnsonsBabyBoldEot}) format("eot");
  font-weight: bold;
};

${reset}

  html {
    scroll-padding-top: 130px;
  }

  html, body, #root{
    height:100%;
  }

  body{
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    font-family: "JohnsonsBaby", sans-serif;
    padding-top: 64px;
    background-color: #fff;
    
    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding-top: 0;
    }

    .text-1{
      font-size: 18px;
      line-height: 26px;
    }
    .text-2{
      font-size: 16px;
      line-height: 24px;
    }
    .text-3{
      font-size: 12px;
      line-height: 16px;
    }
    .text-4{
      font-size: 14px;
    }
  }
  .MuiGrid-container {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    max-width: 1190px;
  }
  .mobileOnly {
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: none;
    }
  }
  .deskOnly {
    display: none;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: initial;
    }
  }
  .sup {
    vertical-align: super;
    font-size: small;
    line-height: 0px;
  }
  &.menu-open, &.modal-open {
    overflow: hidden;
  }
`;

export default GlobalStyle;
